// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fenge[data-v-ddbdeeee]{height:30px;margin-top:20px}.fenge[data-v-ddbdeeee],.footer[data-v-ddbdeeee]{background-color:#333;clear:both}.footer[data-v-ddbdeeee]{padding:20px 0}.footer .footerBox[data-v-ddbdeeee]{width:1000px;margin:0 auto;color:#d2d2d2;font-size:16px;line-height:30px}.footer .footerBox span[data-v-ddbdeeee]{margin-right:30px}", ""]);
// Exports
module.exports = exports;
